export const isJsonString = (
  arg: unknown
): arg is ReturnType<typeof JSON.stringify> => {
  try {
    return typeof arg === "string" && typeof JSON.parse(arg) === "object";
  } catch (_) {
    return false;
  }
};
